import { useEffect, useRef } from 'react';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

const useBodyScrollLock = (condition, options = {}) => {
  // Target element remains scrollable (ie. Dismissible or Nav)
  const targetElement = useRef(null);

  useEffect(() => {
    const element = targetElement.current;

    if (!element) {
      return;
    }

    if (condition) {
      disableBodyScroll(element, options);
    } else {
      enableBodyScroll(element);
    }

    // Clear all body scroll locks on unmount
    return clearAllBodyScrollLocks;
  }, [condition, options]);

  // Returns ref to be used by component
  return targetElement;
};

export default useBodyScrollLock;
